// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2Dv-e","file":"styles_file__5yEz1"};